import { useLayoutEffect } from 'react';
import clsx from 'clsx';
import { Container } from '@/components/container';
import { useMainLayout } from '../';
import { HeaderLogo, HeaderSearch, HeaderTopbar } from '.';
const Header = () => {
  const {
    headerSticky
  } = useMainLayout();
  // Going sticky pulls the header out of flow; the wrapper's padding-top (keyed off
  // this attribute) puts the space back. Both must land in the same frame — with a
  // plain useEffect the browser paints the un-padded page first, so the content
  // jumped a header's height on every scroll past the threshold.
  useLayoutEffect(() => {
    if (headerSticky) {
      document.body.setAttribute('data-sticky-header', 'on');
    } else {
      document.body.removeAttribute('data-sticky-header');
    }
  }, [headerSticky]);
  return <header className={clsx('flex items-center transition-[height] shrink-0 bg-[--tw-header-bg] dark:bg-coal-500 h-[--tw-header-height]', headerSticky && 'transition-[height] fixed z-10 top-0 start-0 end-0 shadow-sm backdrop-blur-md bg-white/70 dark:bg-coal-500/70 dark:border-b dark:border-b-light')}>
      <Container className="flex justify-between items-center gap-2.5 min-w-0">
        <HeaderLogo />
        {/* <HeaderSearch /> */}
        <HeaderTopbar />
      </Container>
    </header>;
};
export { Header };